import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onclick", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "bg-transparent hover:bg-blue-400 text-blue-700 font-semibold hover:text-white py-2 px-4 mt-3 w-full text-sm border border-blue-500 hover:border-transparent rounded-xl disabled:hover:bg-transparent disabled:border-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed",
    type: "button",
    onclick: _ctx.onSendCode,
    disabled: _ctx.isDisabled
  }, " ENVIAR NOVO CÓDIGO ", 8, _hoisted_1))
}